import React from 'react'

const Footer = () => {
    return (
        <div className='app-shell-footer flex justify-end'>
            Copyright © {new Date().getFullYear()}
            <span className='font-semibold px-1 text-[var(--color-text-primary)]'>THE CODING STUDIO</span>
            All rights reserved.
        </div>
    )
}

export default Footer
